/*
 * PASS-943 Modal components taken from @rally/connect-components (a.k.a telemedicine-components)
 * adjusted for RDS-based styling
 */
import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { MEDIA_QUERY } from '@pass-frontend/utility/style-helpers';

export interface Props extends HTMLAttributes<HTMLElement> {
  padding?: boolean;
}

const StyledModalWrapper = styled.div`
  height: 100%;
`;

const Section = styled.section`
  height: 100%;
  margin-bottom: 20px;

  ${MEDIA_QUERY.mobileAndTablet} {
    padding-left: 16px;
    padding-right: 16px;
  }

  header {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
`;

export const ModalBody = (props: Props) => {
  const { children, className, ...restProps } = props;
  const customClassName = className || '';
  return (
    <StyledModalWrapper className="Modal-scroll">
      <Section {...restProps} className={`body ${customClassName}`}>
        {children}
      </Section>
    </StyledModalWrapper>
  );
};
